module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page_i"
    }
  }), _vm._v("Praise for "), _c('em', [_vm._v("She May Not Leave:")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Dry, subversive, and witty, Fay Weldon locks her eye onto every parent’s most neurotic fear and calmly turns the screws.”")]), _vm._v(" "), _c('p', {
    staticClass: "attribution"
  }, [_vm._v("—Bella Pollen, author of "), _c('em', [_vm._v("Midnight Cactus")]), _vm._v(" and "), _c('em', [_vm._v("Hunting Unicorns")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Long a chronicler of the war between the sexes, Weldon takes on motherhood and child rearing. … [Her] trademark acid wit is very much in evidence here, especially on the final pages, which she embellishes with a delicious fillip.”")]), _vm._v(" "), _c('p', {
    staticClass: "attribution"
  }, [_vm._v("—Tina Jordan, "), _c('em', [_vm._v("Entertainment Weekly")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Dry, delicious … Weldon … is far from compassionate—acerbic would be the better word for her clean, clear sentences…”")]), _vm._v(" "), _c('p', {
    staticClass: "attribution"
  }, [_vm._v("—Carolyn See, "), _c('em', [_vm._v("The Washington Post")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Ambitious … interesting … explores the complexity of female relationships, offers an unusual and honest perspective on the history of feminism. Clever … constantly thought provoking read.”")]), _vm._v(" "), _c('p', {
    staticClass: "attribution"
  }, [_vm._v("—"), _c('em', [_vm._v("Elle")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“When you are living in domestic hell after your au pair has left, as I am at present, it is comforting to read about your own situation in a Fay Weldon novel. Her voice, at once satirical and sympathetic, is that of an older woman friend whose advice is often as unpalatable as it is invaluable. … Spine chilling black comedy. This witty, wicked, lethally elegant novel about a very modern predicament held me absolutely gripped in between rushing round with a Hoover, a laundry basket, and a frying pan for the children’s tea before working until midnight. It has already been placed on the shelves of my next au-pair’s room.”")]), _vm._v(" "), _c('p', {
    staticClass: "attribution"
  }, [_vm._v("—Amanda Craig, "), _c('em', [_vm._v("Daily Telegraph")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Wickedly hilarious book … fast paced, playful novel. Throughout the book Fay Weldon’s eye for the comic intersections of language and life is an unrepentant kick. In the end of this rollicking shocker of a book, readers will find many themes to warm to.”")]), _vm._v(" "), _c('p', {
    staticClass: "attribution"
  }, [_vm._v("—Carol Herman, "), _c('em', [_vm._v("The Washington Times")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Feminism observer Weldon turns her sharp eye to the desperate neediness of two-career … parents seeking child care. The results hit very close to the working literary family’s bone.”")]), _vm._v(" "), _c('p', {
    staticClass: "attribution"
  }, [_vm._v("—"), _c('em', [_vm._v("Publishers Weekly")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fa306ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Front.vue
// module id = 63
// module chunks = 0